import { useEffect, useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { useFormik } from 'formik'

import { ApplicationState } from '@/state/root.models'
import { BrandsOptions } from '@/state/brands/models'
import { brandsSelector } from '@/state/brands/slices/index.slices'

import { Brands, UpdateUserPayload } from '@/state/user/models'
import { initialValuesDetails, validationSchemaDetails } from './schema'
import useActions from './use-actions.hook'

const useEditProfile = () => {
  const { loggedUser } = useSelector(({ auth }: ApplicationState) => auth)

  const { brands } = useSelector(brandsSelector, shallowEqual)

  const { updateUser, getAllBrands } = useActions()

  const [showEditProfile, setEditProfile] = useState(false)

  const brandsOptions: BrandsOptions[] =
    brands && brands.length > 0
      ? brands.map((brand: BrandsOptions) => {
          return {
            id: brand.id,
            name: brand.name,
            siteId: brand.siteId,
          }
        })
      : []

  const formikDetails = useFormik({
    initialValues: initialValuesDetails,
    validationSchema: validationSchemaDetails,
    onSubmit: () => {},
    enableReinitialize: true,
  })

  const handleShowTwoEditProfile = () => {
    setEditProfile(!showEditProfile)
  }

  const setLoggedUserValues = () => {
    const newBrands =
      loggedUser.brands.map((brand: Brands) => {
        return {
          id: brand.id,
          name: brand.name,
          siteId: brand.siteId,
        }
      }) || []

    formikDetails.setValues({
      firstname: loggedUser.firstName,
      lastname: loggedUser.lastName,
      username: loggedUser.username,
      email: loggedUser.email,
      brands: newBrands,
      resetPassword: false,
      password: '',
      confirmPassword: '',
    })
  }

  const handleOnSave = () => {
    // Send Profile Changes
    let updatedUser: UpdateUserPayload = {
      id: loggedUser.id,
      role: loggedUser.role,
      username: loggedUser.username,
      firstName: formikDetails.values.firstname,
      lastName: formikDetails.values.lastname,
      brands: formikDetails.values.brands as any,
    }

    if (formikDetails.values.resetPassword) {
      updatedUser = {
        ...updatedUser,
        password: formikDetails.values.password,
      }
    }

    updateUser(updatedUser)
  }

  const handleOnCancel = () => {
    setLoggedUserValues()
    handleShowTwoEditProfile()
  }

  useEffect(() => {
    if (loggedUser) {
      setLoggedUserValues()
    }
  }, [loggedUser]) // eslint-disable-line

  useEffect(() => {
    getAllBrands({})
  }, []) // eslint-disable-line

  return {
    handleOnSave,
    handleOnCancel,
    handleShowTwoEditProfile,
    loggedUser,
    formikDetails,
    brandsOptions,
    showEditProfile,
  }
}

export default useEditProfile
